import { DEAL_WON_STATUSES } from '../../constants';
import type { Deal } from '../../types/domain';
import { dealRevenueForYear, dealRevenueTotal } from './soldRevenue';
import type { Year } from './types';

// « Budget vendu » de la liste des affaires : seules les affaires gagnées ont un vendu. Une
// affaire perdue peut garder un budget_vendu saisi pendant le chiffrage, qui ne doit pas
// gonfler le total de la liste.
// Filtrée sur une année : part de l'année (mêmes montants que le dashboard).
export function dealListSoldRevenue(a: Deal, year: Year = 'all'): number {
  if (!DEAL_WON_STATUSES.includes(a.statut as string)) return 0;
  return year === 'all' ? dealRevenueTotal(a) : dealRevenueForYear(a, year);
}
